module.exports = __webpack_public_path__ + "media/images/pc/specials/common/present_meme-bfaa6c9ecddf3d0736290c1835f3a452.jpg";